import type {
  ConnectionEditState,
  ConnectionEditStateUpdater,
} from "../../viewmodels/board/connections/Connections.types";
import type { SourceTypeId } from "../SourceSettingsRegistry";

export interface SourceSettingsApiAccessor {
  tryGetSourceApi: <T>(sourceTypeId: SourceTypeId) => T | null;
}

export interface SourceSettingsModel {
  boardId?: string;
  editingConnection: ConnectionEditState;
  onUpdate: ConnectionEditStateUpdater;
  sourceSettingsApi?: SourceSettingsApiAccessor;
  t: (key: string) => string;
}

export const getSourceSettingsApiAccessor = (
  api: unknown,
): SourceSettingsApiAccessor | undefined =>
  (api as { connectionSourceSettings?: SourceSettingsApiAccessor })
    .connectionSourceSettings;
